var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      class: ["sales-closures-form-modal", { "is-loading": _vm.isLoading }],
      attrs: { title: _vm.formTitle, active: _vm.isOpen, fullscreen: "" },
      on: {
        "update:active": function ($event) {
          _vm.isOpen = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "p-4 mx-auto max-w-xl" },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "sales-closures-loading-state" }, [
                _c("div", { staticClass: "sales-closures-spinner" }),
                _c(
                  "p",
                  { staticClass: "text-sm text-gray-600 font-semibold" },
                  [_vm._v("Cargando datos del cierre...")]
                ),
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "bg-white border border-gray-200 shadow-sm p-4 rounded-lg mb-4",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between mb-3" },
                      [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "font-bold text-[11px] tracking-wider uppercase text-gray-500 flex items-center",
                          },
                          [
                            _c("i", {
                              staticClass:
                                "bx bx-info-circle text-latinad mr-1 text-base",
                            }),
                            _vm._v(" Resumen de Campaña\n        "),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 text-xs mb-3",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Título")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-latinad text-sm truncate",
                                attrs: {
                                  title: _vm.campaignBaseData.campaignName,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.campaignBaseData.campaignName)
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("ID")]
                            ),
                            _c(
                              "p",
                              { staticClass: "font-bold text-latinad text-sm" },
                              [_vm._v(_vm._s(_vm.campaignBaseData.campaignId))]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 text-xs",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Presupuesto")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-latinad text-base leading-tight",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.stringCurrencyFormatter(
                                      _vm.campaignBaseData.budgetTotal
                                    )
                                  ) + " "
                                ),
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(_vm.summaryCurrency)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Real (Agencia)")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-latinad text-base leading-tight",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.stringCurrencyFormatter(
                                      _vm.campaignBaseData.consumptionReal
                                    )
                                  ) + " "
                                ),
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(_vm.summaryCurrency)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Ppto. Media")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-latinad text-base leading-tight",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.stringCurrencyFormatter(
                                      _vm.campaignBaseData.mediaOwnerBudget
                                    )
                                  ) + " "
                                ),
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(_vm.summaryCurrency)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gradient-to-br from-gray-50 to-white p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Real Medios")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-latinad text-base leading-tight",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.stringCurrencyFormatter(
                                      _vm.campaignBaseData.mediaOwnerConsumption
                                    )
                                  ) + " "
                                ),
                                _c("span", { staticClass: "text-sm" }, [
                                  _vm._v(_vm._s(_vm.summaryCurrency)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid grid-cols-1 md:grid-cols-4 gap-3 text-xs mt-3",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gray-50 p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Fechas Campaña")]
                            ),
                            _c(
                              "p",
                              { staticClass: "font-bold text-latinad text-sm" },
                              [_vm._v(_vm._s(_vm.campaignDateRangeText))]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gray-50 p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Tipo de Campaña")]
                            ),
                            _c(
                              "p",
                              { staticClass: "font-bold text-latinad text-sm" },
                              [_vm._v(_vm._s(_vm.campaignTypeLabel))]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gray-50 p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("Exchange")]
                            ),
                            _c(
                              "p",
                              { staticClass: "font-bold text-latinad text-sm" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.campaignBaseData.exchangeName ||
                                      "No informado"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gray-50 p-3 rounded-md border border-gray-200",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                              },
                              [_vm._v("DSP")]
                            ),
                            _c(
                              "p",
                              { staticClass: "font-bold text-latinad text-sm" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.campaignBaseData.dspName ||
                                      "No informado"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm.campaignBaseData.comments
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "bg-gray-50 p-3 rounded-md border border-gray-200 md:col-span-4",
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1",
                                  },
                                  [_vm._v("Comentario")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "font-bold text-latinad text-sm",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.campaignBaseData.comments)
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-gray-50 p-3 rounded-md border border-gray-200 md:col-span-4",
                          },
                          [
                            _c("details", { staticClass: "cursor-pointer" }, [
                              _c(
                                "summary",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide mb-1 select-none",
                                },
                                [
                                  _vm._v(
                                    "\n              Medios involucrados (" +
                                      _vm._s(_vm.campaignBaseData.mediaCount) +
                                      ")\n            "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-2 text-latinad font-bold text-sm",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.campaignBaseData.mediaList.join(
                                          ", "
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "form",
                  {
                    staticClass: "space-y-4",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.onSaveClick.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-6 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.responsibleAgency ? "1A" : "1")
                                ),
                              ]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Empresa")]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "grid grid-cols-2 gap-5" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Nombre fantasía")]
                              ),
                              _c("vs-input", {
                                staticClass: "w-full form-input-minimalist",
                                class: [
                                  { "is-readonly": _vm.isFantasyNameFixed },
                                  _vm.getFieldBorderClass(
                                    "company_fantasy_name"
                                  ),
                                ],
                                attrs: {
                                  value: _vm.isFantasyNameFixed
                                    ? _vm.companyFantasyNameWithId
                                    : _vm.formData.company_fantasy_name,
                                  placeholder: "Ej: LatinAd",
                                  readonly: _vm.isFantasyNameFixed,
                                },
                                on: {
                                  input: function ($event) {
                                    !_vm.isFantasyNameFixed &&
                                      (_vm.formData.company_fantasy_name =
                                        $event)
                                    _vm.markFieldAsEdited(
                                      "company_fantasy_name"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "text-sm font-medium text-gray-700 mb-1",
                              },
                              [_vm._v("Razón social")]
                            ),
                            _c(
                              "div",
                              {
                                class: _vm.getFieldBorderClass(
                                  "billing_information_id"
                                ),
                              },
                              [
                                _c(
                                  "v-select",
                                  {
                                    staticClass: "reason-social-select",
                                    attrs: {
                                      options: _vm.availableCompanies,
                                      reduce: (company) =>
                                        company.billing_information_id ||
                                        company.id,
                                      label: "name",
                                      clearable: true,
                                      searchable: true,
                                      filterable: true,
                                      "filter-by": _vm.companyFilterBy,
                                      placeholder:
                                        "Buscar y seleccionar razón social",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.onBillingInformationChange(
                                          _vm.formData.billing_information_id
                                        )
                                        _vm.markFieldAsEdited(
                                          "billing_information_id"
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.formData.billing_information_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "billing_information_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.billing_information_id",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "no-options" },
                                        slot: "no-options",
                                      },
                                      [_vm._v("Sin resultados.")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm.responsibleAgency
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center mb-4 mt-6 pb-2 border-b border-gray-100",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "w-6 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                                    },
                                    [_vm._v("1B")]
                                  ),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "font-bold text-sm text-gray-700 tracking-wide uppercase",
                                    },
                                    [_vm._v("Agencia responsable")]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "grid grid-cols-2 gap-5" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-sm font-medium text-gray-700 mb-1",
                                        },
                                        [_vm._v("Nombre fantasía")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist is-readonly",
                                        attrs: {
                                          value: _vm.responsibleAgencyLabel,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-5 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [_vm._v("2")]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Facturación y Pago")]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "grid grid-cols-2 gap-5" }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("billing_mode"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Modo de facturación")]
                              ),
                              _c(
                                "v-select",
                                {
                                  staticClass: "w-full form-v-select",
                                  attrs: {
                                    options: _vm.billingModeOptions,
                                    reduce: (option) => option.value,
                                    label: "label",
                                    clearable: false,
                                    searchable: true,
                                    placeholder: "Buscar y seleccionar",
                                  },
                                  on: {
                                    input: () => {
                                      _vm.onBillingModeChange()
                                      _vm.markFieldAsEdited("billing_mode")
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.billing_mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "billing_mode",
                                        $$v
                                      )
                                    },
                                    expression: "formData.billing_mode",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options",
                                    },
                                    [_vm._v("Sin resultados.")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("payment_mode"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Modo de pago")]
                              ),
                              _c(
                                "v-select",
                                {
                                  staticClass: "w-full form-v-select",
                                  attrs: {
                                    options: _vm.paymentModeOptions,
                                    reduce: (option) => option.value,
                                    label: "label",
                                    clearable: false,
                                    searchable: true,
                                    placeholder: "Buscar y seleccionar",
                                  },
                                  on: {
                                    input: () => {
                                      _vm.onPaymentModeChange()
                                      _vm.markFieldAsEdited("payment_mode")
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.payment_mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "payment_mode",
                                        $$v
                                      )
                                    },
                                    expression: "formData.payment_mode",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options",
                                    },
                                    [_vm._v("Sin resultados.")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("payment_term"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Plazo de pago (días)")]
                              ),
                              _c("vs-input", {
                                staticClass: "w-full form-input-minimalist",
                                attrs: { type: "number", min: "0" },
                                on: {
                                  input: function ($event) {
                                    _vm.onIntegerNonNegativeInput(
                                      "payment_term"
                                    )
                                    _vm.markFieldAsEdited("payment_term")
                                  },
                                },
                                model: {
                                  value: _vm.formData.payment_term,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "payment_term", $$v)
                                  },
                                  expression: "formData.payment_term",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("charge_term"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Plazo de cobro (días)")]
                              ),
                              _c("vs-input", {
                                staticClass: "w-full form-input-minimalist",
                                attrs: { type: "number", min: "0" },
                                on: {
                                  input: function ($event) {
                                    _vm.onIntegerNonNegativeInput("charge_term")
                                    _vm.markFieldAsEdited("charge_term")
                                  },
                                },
                                model: {
                                  value: _vm.formData.charge_term,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "charge_term", $$v)
                                  },
                                  expression: "formData.charge_term",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-5 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [_vm._v("3")]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Período y Monto")]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "grid grid-cols-2 gap-5" }, [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("date_from"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Fecha desde")]
                              ),
                              _c("vs-input", {
                                staticClass: "w-full form-input-minimalist",
                                attrs: { type: "date" },
                                on: { input: _vm.handleDateFromChange },
                                model: {
                                  value: _vm.formData.date_from,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "date_from", $$v)
                                  },
                                  expression: "formData.date_from",
                                },
                              }),
                              _vm.dateRangeAlerts.date_from
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "background-color": "#fb9e2e",
                                        color: "white",
                                        padding: "0.375rem 0.75rem",
                                        "border-radius": "0.5rem",
                                        "font-size": "0.75rem",
                                        "margin-top": "0.5rem",
                                        display: "inline-block",
                                        width: "fit-content",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.dateRangeAlerts.date_from
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("date_to"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Fecha hasta")]
                              ),
                              _c("vs-input", {
                                staticClass: "w-full form-input-minimalist",
                                attrs: {
                                  type: "date",
                                  min: _vm.formData.date_from || null,
                                },
                                on: { input: _vm.handleDateToChange },
                                model: {
                                  value: _vm.formData.date_to,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "date_to", $$v)
                                  },
                                  expression: "formData.date_to",
                                },
                              }),
                              _vm.dateRangeAlerts.date_to
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "background-color": "#fb9e2e",
                                        color: "white",
                                        padding: "0.375rem 0.75rem",
                                        "border-radius": "0.5rem",
                                        "font-size": "0.75rem",
                                        "margin-top": "0.5rem",
                                        display: "inline-block",
                                        width: "fit-content",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.dateRangeAlerts.date_to) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("amount"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Monto")]
                              ),
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("vs-input", {
                                    staticClass: "w-full form-input-minimalist",
                                    attrs: {
                                      type: "number",
                                      min: "0",
                                      step: "0.01",
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.onAmountChange()
                                        _vm.markFieldAsEdited("amount")
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.amount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "amount", $$v)
                                      },
                                      expression: "formData.amount",
                                    },
                                  }),
                                  _vm.isConsumptionExceeded
                                    ? _c("feather-icon", {
                                        attrs: {
                                          icon: "AlertTriangleIcon",
                                          svgClasses:
                                            "w-5 h-5 text-warning cursor-help",
                                          title: _vm.consumptionExceededMessage,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm.isAmountLoading
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-[11px] text-gray-500 mt-1",
                                    },
                                    [_vm._v("Calculando monto...")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-col",
                              class: _vm.getFieldBorderClass("currency"),
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Moneda")]
                              ),
                              _c(
                                "v-select",
                                {
                                  staticClass: "w-full form-v-select",
                                  attrs: {
                                    options: _vm.currencyOptions,
                                    clearable: false,
                                    searchable: true,
                                    placeholder: "Buscar y seleccionar",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.markFieldAsEdited("currency")
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.currency,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "currency", $$v)
                                    },
                                    expression: "formData.currency",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "no-options" },
                                      slot: "no-options",
                                    },
                                    [_vm._v("Sin resultados.")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-8 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [_vm._v("4.1")]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Comisiones e Impuestos")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mb-5 w-1/2 pr-2 flex flex-col",
                            class: _vm.getFieldBorderClass(
                              "agency_commission_mode"
                            ),
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "text-sm font-medium text-gray-700 mb-1",
                              },
                              [_vm._v("Modo de comisión")]
                            ),
                            _c(
                              "v-select",
                              {
                                staticClass: "w-full form-v-select",
                                attrs: {
                                  options: _vm.agencyCommissionModeOptions,
                                  reduce: (option) => option.value,
                                  label: "label",
                                  clearable: false,
                                  searchable: true,
                                  placeholder: "Buscar y seleccionar",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.markFieldAsEdited(
                                      "agency_commission_mode"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.formData.agency_commission_mode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "agency_commission_mode",
                                      $$v
                                    )
                                  },
                                  expression: "formData.agency_commission_mode",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "no-options" },
                                    slot: "no-options",
                                  },
                                  [_vm._v("Sin resultados.")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "space-y-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-gray-50 p-3.5 rounded-lg border border-gray-200 relative hover:border-amber-200 transition-colors",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "absolute top-0 left-0 w-full h-1 bg-amber-400",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-xs font-bold text-gray-800 mb-3 uppercase tracking-wide mt-1",
                                },
                                [_vm._v("Agencia")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid grid-cols-1 md:grid-cols-3 gap-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "agency_commission_percentage"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Porcentaje (%)")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.onCommissionPercentageChange(
                                              "agency_commission_percentage"
                                            )
                                            _vm.markFieldAsEdited(
                                              "agency_commission_percentage"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .agency_commission_percentage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "agency_commission_percentage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.agency_commission_percentage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Monto")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onCommissionAmountChange(
                                              "agency_commission_amount"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .agency_commission_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "agency_commission_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.agency_commission_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "agency_commission_currency"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Moneda")]
                                      ),
                                      _c(
                                        "v-select",
                                        {
                                          staticClass:
                                            "w-full mini-select form-v-select",
                                          attrs: {
                                            options: _vm.currencyOptions,
                                            clearable: false,
                                            searchable: true,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.markFieldAsEdited(
                                                "agency_commission_currency"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .agency_commission_currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "agency_commission_currency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.agency_commission_currency",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options",
                                            },
                                            [_vm._v("Sin resultados.")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-gray-50 p-3.5 rounded-lg border border-gray-200 relative hover:border-blue-200 transition-colors",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "absolute top-0 left-0 w-full h-1 bg-blue-500",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-xs font-bold text-gray-800 mb-3 uppercase tracking-wide mt-1",
                                },
                                [_vm._v("Exchange")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid grid-cols-1 md:grid-cols-3 gap-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "exchange_commission_percentage"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Porcentaje (%)")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.onCommissionPercentageChange(
                                              "exchange_commission_percentage"
                                            )
                                            _vm.markFieldAsEdited(
                                              "exchange_commission_percentage"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .exchange_commission_percentage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "exchange_commission_percentage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.exchange_commission_percentage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Monto")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onCommissionAmountChange(
                                              "exchange_commission_amount"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .exchange_commission_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "exchange_commission_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.exchange_commission_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "exchange_commission_currency"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Moneda")]
                                      ),
                                      _c(
                                        "v-select",
                                        {
                                          staticClass:
                                            "w-full mini-select form-v-select",
                                          attrs: {
                                            options: _vm.currencyOptions,
                                            clearable: false,
                                            searchable: true,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.markFieldAsEdited(
                                                "exchange_commission_currency"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .exchange_commission_currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "exchange_commission_currency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.exchange_commission_currency",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options",
                                            },
                                            [_vm._v("Sin resultados.")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-gray-50 p-3.5 rounded-lg border border-gray-200 relative hover:border-emerald-200 transition-colors",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "absolute top-0 left-0 w-full h-1 bg-emerald-500",
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-xs font-bold text-gray-800 mb-3 uppercase tracking-wide mt-1 flex items-center",
                                },
                                [
                                  _vm._v(
                                    "\n              Impuestos Nacionales\n              "
                                  ),
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "InfoIcon",
                                      svgClasses:
                                        "w-4 h-4 text-gray-400 ml-1 cursor-help",
                                      title:
                                        "Sugerido según el país de facturación de la razón social.",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid grid-cols-1 md:grid-cols-3 gap-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "national_tax_percentage"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Porcentaje (%)")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.onCommissionPercentageChange(
                                              "national_tax_percentage"
                                            )
                                            _vm.markFieldAsEdited(
                                              "national_tax_percentage"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .national_tax_percentage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "national_tax_percentage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.national_tax_percentage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "national_tax_amount"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Monto")]
                                      ),
                                      _c("vs-input", {
                                        staticClass:
                                          "w-full form-input-minimalist",
                                        attrs: {
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                        },
                                        on: {
                                          input: function ($event) {
                                            _vm.onCommissionAmountChange(
                                              "national_tax_amount"
                                            )
                                            _vm.markFieldAsEdited(
                                              "national_tax_amount"
                                            )
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.formData.national_tax_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "national_tax_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.national_tax_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-col",
                                      class: _vm.getFieldBorderClass(
                                        "national_tax_currency"
                                      ),
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-xs font-semibold text-gray-700 mb-1",
                                        },
                                        [_vm._v("Moneda")]
                                      ),
                                      _c(
                                        "v-select",
                                        {
                                          staticClass:
                                            "w-full mini-select form-v-select",
                                          attrs: {
                                            options: _vm.currencyOptions,
                                            clearable: false,
                                            searchable: true,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.markFieldAsEdited(
                                                "national_tax_currency"
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .national_tax_currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "national_tax_currency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.national_tax_currency",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options",
                                            },
                                            [_vm._v("Sin resultados.")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-between pb-2 border-b border-gray-100 cursor-pointer select-none",
                            attrs: { role: "button", tabindex: "0" },
                            on: {
                              click: _vm.toggleWhtSection,
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.toggleWhtSection.apply(
                                    null,
                                    arguments
                                  )
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.toggleWhtSection.apply(
                                    null,
                                    arguments
                                  )
                                },
                              ],
                            },
                          },
                          [
                            _c("div", { staticClass: "flex items-center" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "w-8 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                                },
                                [_vm._v("4.2")]
                              ),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "font-bold text-sm text-gray-700 tracking-wide uppercase",
                                },
                                [_vm._v("Ajuste WHT")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "ml-2 text-[11px] text-gray-400 font-medium",
                                },
                                [_vm._v("(opcional)")]
                              ),
                            ]),
                            _c("feather-icon", {
                              attrs: {
                                icon: _vm.isWhtSectionOpen
                                  ? "ChevronUpIcon"
                                  : "ChevronDownIcon",
                                svgClasses: "w-5 h-5 text-gray-400",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isWhtSectionOpen,
                                expression: "isWhtSectionOpen",
                              },
                            ],
                            staticClass: "mt-4 space-y-4",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid grid-cols-1 md:grid-cols-2 gap-4",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "text-sm font-semibold text-gray-700 mb-1",
                                      },
                                      [_vm._v("Base de cálculo")]
                                    ),
                                    _c("vs-input", {
                                      staticClass:
                                        "w-full form-input-minimalist",
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        step: "0.01",
                                      },
                                      on: { input: _vm.onWhtBaseChange },
                                      model: {
                                        value:
                                          _vm.formData.wht_calculation_base,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "wht_calculation_base",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.wht_calculation_base",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "text-sm font-semibold text-gray-700 mb-1",
                                      },
                                      [_vm._v("Moneda")]
                                    ),
                                    _c(
                                      "v-select",
                                      {
                                        staticClass:
                                          "w-full mini-select form-v-select",
                                        attrs: {
                                          options: _vm.currencyOptions,
                                          clearable: false,
                                          searchable: true,
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .international_tax_currency,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "international_tax_currency",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.international_tax_currency",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "no-options" },
                                            slot: "no-options",
                                          },
                                          [_vm._v("Sin resultados.")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-gray-50 p-3.5 rounded-lg border border-gray-200 relative",
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "absolute top-0 left-0 w-full h-1 bg-red-500",
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-xs font-bold text-gray-800 mb-3 uppercase tracking-wide mt-1",
                                  },
                                  [_vm._v("Tax Int.")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid grid-cols-1 md:grid-cols-3 gap-4",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex flex-col",
                                        class: _vm.getFieldBorderClass(
                                          "international_tax_percentage"
                                        ),
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "text-xs font-semibold text-gray-700 mb-1",
                                          },
                                          [_vm._v("Porcentaje (%)")]
                                        ),
                                        _c("vs-input", {
                                          staticClass:
                                            "w-full form-input-minimalist",
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            step: "0.01",
                                          },
                                          on: {
                                            input: _vm.onWhtPercentageChange,
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .international_tax_percentage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "international_tax_percentage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.international_tax_percentage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "text-xs font-semibold text-gray-700 mb-1",
                                          },
                                          [_vm._v("Monto")]
                                        ),
                                        _c("vs-input", {
                                          staticClass:
                                            "w-full form-input-minimalist",
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            step: "0.01",
                                          },
                                          on: { input: _vm.onWhtAmountChange },
                                          model: {
                                            value:
                                              _vm.formData
                                                .international_tax_amount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "international_tax_amount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.international_tax_amount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "text-xs font-semibold text-gray-700 mb-1",
                                          },
                                          [_vm._v("Moneda")]
                                        ),
                                        _c(
                                          "v-select",
                                          {
                                            staticClass:
                                              "w-full mini-select form-v-select is-readonly",
                                            attrs: {
                                              value:
                                                _vm.formData
                                                  .international_tax_currency,
                                              options: _vm.currencyOptions,
                                              clearable: false,
                                              searchable: false,
                                              disabled: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "no-options" },
                                                slot: "no-options",
                                              },
                                              [_vm._v("Sin resultados.")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-5 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [_vm._v("5")]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Resumen")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "grid grid-cols-2 gap-y-3 gap-x-6 text-sm",
                          },
                          [
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Pago de Agencia")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary.agency_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Pago a Medios")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary.media_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Comisión de Agencia")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary
                                          .agency_commission_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Comisión de Exchange")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary
                                          .exchange_commission_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Impuestos Internacionales")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary
                                          .international_tax_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                },
                                [_vm._v("Impuestos Nacionales")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "font-bold text-latinad text-base",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closureSummary.national_tax_payment
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.closureSummary.currency)
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "border-t border-gray-100 pt-3" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                  },
                                  [_vm._v("Monto Neto")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "font-bold text-latinad text-lg",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.stringCurrencyFormatter(
                                          _vm.closureSummary.net_amount
                                        )
                                      ) +
                                        " " +
                                        _vm._s(_vm.closureSummary.currency)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "border-t border-gray-100 pt-3" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-gray-500 text-[10px] uppercase font-bold tracking-wide",
                                  },
                                  [_vm._v("Monto a Facturar")]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "font-bold text-latinad text-lg",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.stringCurrencyFormatter(
                                          _vm.closureSummary.billing_amount
                                        )
                                      ) +
                                        " " +
                                        _vm._s(_vm.closureSummary.currency)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-gray-200 shadow-sm rounded-lg p-5",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center mb-4 pb-2 border-b border-gray-100",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "w-5 h-5 rounded-full bg-latinad text-white flex items-center justify-center text-[10px] font-bold mr-2",
                              },
                              [_vm._v("6")]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "font-bold text-sm text-gray-700 tracking-wide uppercase",
                              },
                              [_vm._v("Comentarios")]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "grid grid-cols-1 gap-5" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Observación de cierre")]
                              ),
                              _c("vs-textarea", {
                                staticClass: "w-full",
                                attrs: {
                                  rows: 3,
                                  maxlength: "1000",
                                  placeholder:
                                    "Ingrese un comentario u observaciones para explicar los cambios que se realizaron",
                                },
                                model: {
                                  value: _vm.formData.closure_observation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "closure_observation",
                                      $$v
                                    )
                                  },
                                  expression: "formData.closure_observation",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "text-sm font-medium text-gray-700 mb-1",
                                },
                                [_vm._v("Comentario de facturación")]
                              ),
                              _c("vs-textarea", {
                                staticClass: "w-full",
                                attrs: {
                                  rows: 3,
                                  maxlength: "1000",
                                  placeholder:
                                    "Si corresponde, ingrese instrucciones para el facturador",
                                },
                                model: {
                                  value: _vm.formData.billing_comment,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "billing_comment",
                                      $$v
                                    )
                                  },
                                  expression: "formData.billing_comment",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "pt-2 pb-4 space-y-4" }, [
                      _vm.validationErrors.length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "validation-errors-box rounded p-4 shadow-sm",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-danger font-bold mb-2 text-sm uppercase flex items-center",
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "AlertCircleIcon",
                                      svgClasses: "w-4 h-4 mr-2",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            Revise los siguientes campos:\n          "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "list-disc list-inside text-danger text-base font-semibold",
                                },
                                _vm._l(
                                  _vm.validationErrors,
                                  function (error, idx) {
                                    return _c(
                                      "li",
                                      { key: idx, staticClass: "mb-1" },
                                      [_vm._v(_vm._s(error))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "flex gap-3 mt-4" },
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass:
                                "flex-1 font-bold tracking-wide py-2 shadow-sm transition-colors",
                              attrs: { color: "dark", type: "border" },
                              on: { click: _vm.handleClose },
                            },
                            [_vm._v("\n            Cancelar\n          ")]
                          ),
                          _c(
                            "vs-button",
                            {
                              staticClass:
                                "flex-1 font-bold tracking-wide py-2 shadow border-0",
                              attrs: { color: "primary", type: "filled" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onSaveClick.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("\n            Guardar\n          ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
        ],
        2
      ),
      _vm.isSaveChoiceModalOpen
        ? _c(
            "div",
            {
              staticClass:
                "fixed inset-0 z-[100001] bg-black/40 flex items-center justify-center px-4",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.handleSaveChoiceClose.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-full max-w-md bg-white rounded-lg shadow-xl border border-gray-200 p-4",
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center justify-between mb-3" },
                    [
                      _c("h4", { staticClass: "font-bold text-gray-800" }, [
                        _vm._v("Guardar cierre"),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass:
                            "w-8 h-8 rounded-full border border-gray-200 text-gray-500 hover:text-gray-700 hover:bg-gray-100 flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-latinad/30",
                          attrs: { type: "button", "aria-label": "Cerrar" },
                          on: { click: _vm.handleSaveChoiceClose },
                        },
                        [_c("i", { staticClass: "feather icon-x text-base" })]
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "text-sm text-gray-700 mb-4" }, [
                    _vm._v(_vm._s(_vm.saveChoiceDescription)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "flex gap-2" },
                    [
                      _vm.canSaveAsDraft
                        ? _c(
                            "vs-button",
                            {
                              staticClass: "flex-1",
                              attrs: { color: "warning", type: "filled" },
                              on: {
                                click: function ($event) {
                                  return _vm.onSaveChoice(
                                    _vm.CLOSURE_STATUS.DRAFT
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          Guardar como Borrador\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "vs-button",
                        {
                          class: _vm.canSaveAsDraft ? "flex-1" : "w-full",
                          attrs: { color: "primary", type: "filled" },
                          on: {
                            click: function ($event) {
                              return _vm.onSaveChoice(_vm.CLOSURE_STATUS.VALID)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isEditingValidClosure
                                  ? "Confirmar"
                                  : "Guardar como Final"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }